/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Unable
 *
 * 2 = AbleToRequest
 *
 * 3 = Received
 */
export enum StatusStageStatus {
  Unable = 1,
  AbleToRequest = 2,
  Received = 3,
}
